export default {
  currency: {
    useConversions: false,
    default: "USD",
    availableCurrencies: [],
  },
};
